export default __webpack_public_path__ + "static/media/alert_info_icon.07a2f565.svg";